module.exports = __webpack_public_path__ + "img/whatsap_logo.98f106f3.svg";